import React, { useState, useEffect } from 'react';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const heroSlides = [
    {
      id: 0,
      image: "/content/images/homepage/hero/en_US/hp-hero-citi-public-07082025.jpg",
      alt: "Citi / AAdvantage credit card. Earn up to 80,000 bonus miles with this credit card offer. Opens another site in a new window that may not meet accessibility guidelines.",
      link: "https://creditcards.aa.com/?utm_medium=referral&utm_source=aa&utm_campaign=hp_upto"
    },
    {
      id: 1,
      image: "/content/images/homepage/hero/en_US/hp-hero-fares-south-america-08112025.jpg",
      alt: "South America flights from $499 round trip. Fly to Bogota, Buenos Aires, Lima and more. Opens another site in a new window that may not meet accessibility guidelines.",
      link: "https://www.aa.com/en-us/latin-america-deals?c=DSP||20250818|MKT|USPFMOC|HRO||US_ROUTE_TRAN_MCLA_SOUTH_AMERICA_SALE"
    },
    {
      id: 2,
      image: "/content/images/homepage/hero/en_US/hp-hero-stand-up-to-cancer-08152025.jpg",
      alt: "Let's go further, together. Help support cancer research and earn miles. Opens another site in a new window that may not meet accessibility guidelines.",
      link: "https://standuptocancer.org/get-involved/american-airlines-donate-25-mile/?overlay=aa&utm_source=AA&utm_medium=AA_WEB&utm_campaign=AA_MC_2025_Show_Offer_HP_Hero"
    }
  ];

  useEffect(() => {
    if (!isPaused) {
      const timer = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
      }, 5000);
      return () => clearInterval(timer);
    }
  }, [isPaused, heroSlides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  };

  const togglePause = () => {
    setIsPaused(!isPaused);
  };

  return (
    <div className="relative h-96 md:h-[594px] overflow-hidden">
      {/* Hero Slides */}
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <a href={slide.link} className="block h-full">
            <img
              src={slide.image}
              alt={slide.alt}
              className="w-full h-full object-cover"
            />
          </a>
        </div>
      ))}

      {/* Navigation Controls */}
      <div className="absolute inset-0 flex items-center">
        <button
          onClick={goToPrevious}
          className="absolute left-[-10px] h-full w-14 bg-gray-500 bg-opacity-20 hover:bg-black hover:bg-opacity-50 flex items-center justify-center transition-all"
        >
          <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        
        <button
          onClick={goToNext}
          className="absolute right-[-10px] h-full w-14 bg-gray-500 bg-opacity-20 hover:bg-black hover:bg-opacity-50 flex items-center justify-center transition-all"
        >
          <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      {/* Pause/Play Button */}
      <button
        onClick={togglePause}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          top: '325px',
          padding: '0px',
          left: '45px',
          width: '30px',
          height: '30px',
          background: 'rgba(0, 0, 0, 0.4)',
          overflow: 'hidden',
          zIndex: 20,
          pointerEvents: 'auto',
          border: 'none',
          cursor: "pointer"
        }}
      >
        {isPaused ? (
          <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z"/>
          </svg>
        ) : (
          <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
            <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
          </svg>
        )}
      </button>

     
    </div>
  );
};

export default Hero;
